<template>
  <div class="content">
    <header>
      <i class="iconfont icon-home_location_icon_l"></i>
      <p>加盟纪录</p>
    </header>
    <div class="cont">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-cell v-for="item in list" :key="item" :title="item" />
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false
    };
  },
  mounted() {},
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  header {
    display: flex;
    align-items: center;
    height: 44px;
    i {
      font-size: 26px;
    }
    p {
      font-size: 18px;
      margin-left: 120px;
    }
  }
  .cont {
    p {
      font-size: 16px;
      text-align: center;
      line-height: 16px;
    }
    .success {
      display: block;
      font-size: 88px;
      color: #4ecb74;
      margin: 104px auto 32px;
    }

    .btn {
      width: 231px;
      height: 44px;
      border-radius: 25px;
    }
    .return {
      margin: 40px auto 21px;
    }
  }
}
</style>
